import axios from "axios";
import api from "@/services/api";

export interface ReactivationResult {
  subscription_id: string;
  status: string;
  current_period_end: string | null;
}

export class ReactivationRequestError extends Error {
  constructor(
    message: string,
    public readonly code?: string,
  ) {
    super(message);
    this.name = "ReactivationRequestError";
  }
}

export const reactivateSubscription = async (): Promise<ReactivationResult> => {
  try {
    const response = await api.post<ReactivationResult>(
      "/payments/subscription/reactivate/",
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const payload = error.response?.data as
        | { code?: string; detail?: string }
        | undefined;
      throw new ReactivationRequestError(
        payload?.detail ?? "We couldn't reactivate your subscription. Try again.",
        payload?.code,
      );
    }
    throw new ReactivationRequestError(
      "We couldn't reactivate your subscription. Try again.",
    );
  }
};